import React from "react";
import { Link } from "react-router-dom";

function Header() {
  return (
    <header className="w-full px-6 py-4 flex justify-center items-center absolute top-0 left-0 z-50">
      {/* Logo / Brand */}
      <Link to="/" className="flex items-center gap-3 text-white text-xl font-bold tracking-wide">
        <img
          src="/images/chord-finder-logo.png"
          alt="Digital Ladyland Logo"
          className="h-32 w-auto"
        />
      </Link>
    </header>
  );
}

export default Header;
